import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { createPublishRovoSelectionEffect } from '@databases/rovo-bridge/selections-effect';
import { getService } from '@databases/service-container';
import {
  type DatabaseLayoutType,
  isBuiltInDatabaseLayoutType,
} from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import {
  SelectionFeatureKeys,
  type SelectionEffectFeature,
} from '../../features/types.ts';

export interface PublishRovoEffectFeatureLifecycleDeps {
  currentViewType: DatabaseLayoutType | undefined;
}

export function createPublishRovoEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.PUBLISH_ROVO_EFFECT,
    type: 'effect',
    isEnabled: ({ layoutType }) => layoutType !== TABLE_V2_LAYOUT_ID,
    factory: () => {
      const currentView = getCachedViewSnapshotForSelections();
      const layoutType = currentView.settings.layout.type;

      return createPublishRovoSelectionEffect({
        selectionsApi: getService('SelectionsApi'),
        publishSelectionToRovo: (selection: string[]) => {
          waitForContentAPI().then((contentAPI) => {
            contentAPI?.publishDatabaseReferencingContent?.(selection);
          });
        },
        currentViewType: isBuiltInDatabaseLayoutType(layoutType) ? layoutType : undefined,
      });
    },
  };
}
